// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"358f8af7","453":"c712e79c","455":"714e93b0","977":"31045cc5"}[chunkId] + ".chunk.js";
};